import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { IntercomProvider } from "react-use-intercom";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { initThirdPartyApis } from "./api/third-party.ts";
import "../../../index.css";

initThirdPartyApis();
recoverFromStaleDeploy();

/**
 * A hashed chunk is gone once a deploy replaces it, so a tab left open lands on a
 * dead screen when it lazily imports a route. The service-worker prompt only covers
 * tabs that notice the new version, so reload here - guarded by a timestamp, since a
 * genuinely missing chunk must not turn into a reload loop.
 */
function recoverFromStaleDeploy() {
  const RELOAD_KEY = "stale-deploy-reloaded-at";
  const RELOAD_COOLDOWN_MS = 60_000;
  window.addEventListener("vite:preloadError", (event) => {
    const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) {
      return;
    }
    event.preventDefault();
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
  });
}

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <IntercomProvider autoBoot appId={INTERCOM_APP_ID}>
    <App />
  </IntercomProvider>,
);

if (import.meta.env.DEV) {
  loadDevMessages();
  loadErrorMessages();
}
